var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"SectionApply"}},[_c('Wrap',[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('div',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.$t('subtitle' ))+" ")]),_c('div',{staticClass:"notice"},[_vm._v(" "+_vm._s(_vm.$t('notice'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }